// extracted by mini-css-extract-plugin
export default {"space":"style_space__MsVxA","filters-block":"style_filters-block__MhWHG","filters":"style_filters__b-g5f"};